import { createElement } from "commonAssets/js/helpers";
import { appVersion, i18n } from "commonAssets/js/constants";

export function createFooter() {
    const currentYear = new Date().getFullYear();
    const container = createElement("div");
    const elements = `
        <div class="text-center py-3">
            <span id="copyright">&copy; ${currentYear}</span>
            <span class="pipe"> | </span>
            <span id="privacy-policy">
                <a href="${i18n.getTranslation('privacy_policy_url')}" 
                    target="_blank" rel="noopener noreferrer" 
                    aria-label="${i18n.getTranslation('privacy_policy')}">
                    ${i18n.getTranslation('privacy_policy')}
                </a>
            </span>
            <span class="pipe"> | </span>
            <span id="do-not-sell">
                <a href='javascript:void(0)' onclick='revisitCkyConsent()'>Do Not Sell or Share My Personal Information</a>
            </span>
            <span class="pipe"> | </span>
            <span id="version">${i18n.getTranslation('version')} ${appVersion}</span>
        </div>
        `;
    container.innerHTML = elements;
    return container;
}